module.exports = __webpack_public_path__ + "static/media/correct_scan.4c2c9e74.mp3";